import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import "../../../resources/styles.scss";
import * as cardsStyles from '../cards.module.scss';
import { utils } from '../../../utils/utils.js';
import { Check } from '../../../components/view_controls/check';

class ViewCardLimit extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.props.item);

        this.removeAction = this.removeAction.bind(this);
        this.editAction = this.editAction.bind(this);
        this.toLimitStateName = this.toLimitStateName.bind(this);
    }
    
    editAction(e) {
        e.preventDefault();
        this.props.editAction(this.state.limitId);
    }

    removeAction(e) {
        e.preventDefault();
        this.props.removeAction(this.props.item);
    }
    
    toLimitStateName(value) {
        switch (value) {
        case 0:
            return this.props.i18n.t("Limits.notUseLimitState");
        case 1:
            return this.props.i18n.t("Limits.useLimitState");
        case 2:
            return this.props.i18n.t("Limits.stopSupplyState");
        default:
            return value;
        }
    }

    render() {
        return (
            <div className={cardsStyles.view_card_limit_form}>
                <div className={cardsStyles.view_card_limit_header}>
                    <div className={cardsStyles.button_container}>
                        {this.props.canEdit && <button className={cardsStyles.remove_card_limit_btn} onClick={this.removeAction}></button>}
                        {this.props.canEdit && <button className={cardsStyles.edit_card_limit_btn} onClick={this.editAction}></button>}
                    </div>
                </div>
                <div className={cardsStyles.view_card_limit_body}>
                    <div>
                        <div>
                            <label><Trans>Limits.fuelType</Trans></label>
                            <div>{this.state.fuelType}</div>
                        </div>
                        <div>
                            <label><Trans>Limits.limitState</Trans></label>
                            <div>{this.toLimitStateName(this.state.limitState)}</div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label><Trans>Limits.dateLimit</Trans></label>
                            <div>{this.state.dateLimit}</div>
                        </div>
                        <div>
                            <label><Trans>Limits.totalVolume</Trans></label>
                            <div>{this.state.totalVolume}</div>
                        </div>
                    </div>
                    <div>                  
                        <div>
                            <label><Trans>Limits.movingTs</Trans></label>
                            <div>{utils.formatDate(new Date(this.state.movingTs.split('.')[0] + ".000Z"))}</div>
                        </div>                        
                        <div>
                            <label><Trans>Limits.movingNumber</Trans></label>
                            <div>{this.state.movingNumber}</div>
                        </div>      
                    </div>
                    <div>                  
                        <div style={{display: 'flex', flexDirection: 'row', gap: '15px'}}>
                            <label><Trans>Limits.limitReal</Trans>?</label>
                            <div><Check style={{backgroundColor: "white"}} checked={this.state.limitReal}></Check></div>
                            
                        </div>     
                    </div>
                </div>

            </div>);
    }
}

export default withTranslation("translations")(ViewCardLimit);
